// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as OrderType from "../../../../library/data-source/order/entity/OrderType.bs.js";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as Json_encode from "../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as FilterOrderBrand from "./FilterOrderBrand.bs.js";
import * as FilterOrderSource from "./FilterOrderSource.bs.js";
import * as FilterOrderStatus from "./FilterOrderStatus.bs.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ReasonUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReasonUtils.bs.js";
import * as StringUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
  if (order_id.TAG === /* Ok */0) {
    var customer_mobile = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_mobile"), null));
    if (customer_mobile.TAG === /* Ok */0) {
      var email = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        var msisdn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
        if (msisdn.TAG === /* Ok */0) {
          var driver_mobile = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_mobile"), null));
          if (driver_mobile.TAG === /* Ok */0) {
            var source = Decco.optionFromJson(FilterOrderSource.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "source"), null));
            if (source.TAG === /* Ok */0) {
              var order_status = Decco.optionFromJson(FilterOrderStatus.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_status"), null));
              if (order_status.TAG === /* Ok */0) {
                var geo_region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region"), null));
                if (geo_region.TAG === /* Ok */0) {
                  var order_type = Decco.optionFromJson(OrderType.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_type"), null));
                  if (order_type.TAG === /* Ok */0) {
                    var start_datetime = Decco.optionFromJson(Timestamp$Catalyst.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_datetime"), null));
                    if (start_datetime.TAG === /* Ok */0) {
                      var end_datetime = Decco.optionFromJson(Timestamp$Catalyst.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_datetime"), null));
                      if (end_datetime.TAG === /* Ok */0) {
                        var brand = Decco.optionFromJson(FilterOrderBrand.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
                        if (brand.TAG === /* Ok */0) {
                          var virtual_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "virtual_number"), null));
                          if (virtual_number.TAG === /* Ok */0) {
                            var is_dn_requested = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_dn_requested"), null));
                            if (is_dn_requested.TAG === /* Ok */0) {
                              var is_business = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_business"), null));
                              if (is_business.TAG === /* Ok */0) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: {
                                          order_id: order_id._0,
                                          customer_mobile: customer_mobile._0,
                                          email: email._0,
                                          msisdn: msisdn._0,
                                          driver_mobile: driver_mobile._0,
                                          source: source._0,
                                          order_status: order_status._0,
                                          geo_region: geo_region._0,
                                          order_type: order_type._0,
                                          start_datetime: start_datetime._0,
                                          end_datetime: end_datetime._0,
                                          brand: brand._0,
                                          virtual_number: virtual_number._0,
                                          is_dn_requested: is_dn_requested._0,
                                          is_business: is_business._0
                                        }
                                      };
                              }
                              var e = is_business._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".is_business" + e.path,
                                        message: e.message,
                                        value: e.value
                                      }
                                    };
                            }
                            var e$1 = is_dn_requested._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".is_dn_requested" + e$1.path,
                                      message: e$1.message,
                                      value: e$1.value
                                    }
                                  };
                          }
                          var e$2 = virtual_number._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".virtual_number" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                  }
                                };
                        }
                        var e$3 = brand._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".brand" + e$3.path,
                                  message: e$3.message,
                                  value: e$3.value
                                }
                              };
                      }
                      var e$4 = end_datetime._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".end_datetime" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                              }
                            };
                    }
                    var e$5 = start_datetime._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".start_datetime" + e$5.path,
                              message: e$5.message,
                              value: e$5.value
                            }
                          };
                  }
                  var e$6 = order_type._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".order_type" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                          }
                        };
                }
                var e$7 = geo_region._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".geo_region" + e$7.path,
                          message: e$7.message,
                          value: e$7.value
                        }
                      };
              }
              var e$8 = order_status._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".order_status" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                      }
                    };
            }
            var e$9 = source._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".source" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = driver_mobile._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".driver_mobile" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
        }
        var e$11 = msisdn._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".msisdn" + e$11.path,
                  message: e$11.message,
                  value: e$11.value
                }
              };
      }
      var e$12 = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e$12.path,
                message: e$12.message,
                value: e$12.value
              }
            };
    }
    var e$13 = customer_mobile._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".customer_mobile" + e$13.path,
              message: e$13.message,
              value: e$13.value
            }
          };
  }
  var e$14 = order_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_id" + e$14.path,
            message: e$14.message,
            value: e$14.value
          }
        };
}

function getFromDict(dict, key, fromString) {
  var strOpt = Js_dict.get(dict, key);
  return Belt_Option.flatMap(strOpt, (function (str) {
                if (str.length !== 0) {
                  return Caml_option.some(Curry._1(fromString, str));
                }
                
              }));
}

function getFromDictString(dict, key) {
  var strOpt = Js_dict.get(dict, key);
  return Belt_Option.flatMap(strOpt, (function (str) {
                return str;
              }));
}

function getDefaultDateTime(time) {
  if (typeof time === "number") {
    if (time !== 0) {
      return Timestamp$Catalyst.endOf(Timestamp$Catalyst.now(undefined), /* Day */5);
    } else {
      return Timestamp$Catalyst.startOf(Timestamp$Catalyst.now(undefined), /* Day */5);
    }
  } else {
    return Timestamp$Catalyst.make(Number(time._0));
  }
}

function fromDict(map) {
  var order_id = getFromDictString(map, "order_id");
  return {
          order_id: order_id,
          customer_mobile: getFromDictString(map, "customer_mobile"),
          email: getFromDictString(map, "email"),
          msisdn: getFromDictString(map, "msisdn"),
          driver_mobile: getFromDictString(map, "driver_mobile"),
          source: getFromDict(map, "source", FilterOrderSource.fromString),
          order_status: getFromDict(map, "order_status", FilterOrderStatus.fromString),
          geo_region: getFromDict(map, "geo_region", (function (city) {
                  return window.decodeURIComponent(city);
                })),
          order_type: getFromDict(map, "order_type", OrderType.fromString),
          start_datetime: Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(map, "start_epoch_millis"), StringUtils$Catalyst.getStringOptional), Belt_Option.isNone(order_id) ? Caml_option.some(getDefaultDateTime(/* Start */0)) : undefined, (function (date_str) {
                  return Caml_option.some(getDefaultDateTime(/* DateTime */{
                                  _0: date_str
                                }));
                })),
          end_datetime: Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(map, "end_epoch_millis"), StringUtils$Catalyst.getStringOptional), Belt_Option.isNone(order_id) ? Caml_option.some(getDefaultDateTime(/* End */1)) : undefined, (function (date_str) {
                  return Caml_option.some(getDefaultDateTime(/* DateTime */{
                                  _0: date_str
                                }));
                })),
          brand: getFromDict(map, "brand", FilterOrderBrand.fromString),
          virtual_number: getFromDictString(map, "virtual_number"),
          is_dn_requested: Belt_Option.map(getFromDictString(map, "is_delivery_note_requested"), (function (str) {
                  return str === "true";
                })),
          is_business: Belt_Option.map(getFromDictString(map, "is_business"), (function (str) {
                  return str === "true";
                }))
        };
}

function getFromJson(json, key, fromString) {
  return Belt_Option.flatMap(Json_decode.optional((function (param) {
                    return Json_decode.field(key, Json_decode.string, param);
                  }), json), (function (value) {
                return Caml_option.some(Curry._1(fromString, value));
              }));
}

function getFromJsonString(json, key) {
  return Belt_Option.flatMap(Json_decode.optional((function (param) {
                    return Json_decode.field(key, Json_decode.string, param);
                  }), json), (function (value) {
                return value;
              }));
}

function decodeFilterOrderRequest(json) {
  return {
          order_id: getFromJsonString(json, "order_id"),
          customer_mobile: getFromJsonString(json, "customer_mobile"),
          email: getFromJsonString(json, "email"),
          msisdn: getFromJsonString(json, "msisdn"),
          driver_mobile: getFromJsonString(json, "driver_mobile"),
          source: getFromJson(json, "source", FilterOrderSource.fromString),
          order_status: getFromJson(json, "order_status", FilterOrderStatus.fromString),
          geo_region: getFromJsonString(json, "geo_region"),
          order_type: getFromJson(json, "order_type", OrderType.fromString),
          start_datetime: getFromJson(json, "start_epoch_millis", (function (s) {
                  return Timestamp$Catalyst.make(Number(s));
                })),
          end_datetime: getFromJson(json, "end_epoch_millis", (function (s) {
                  return Timestamp$Catalyst.make(Number(s));
                })),
          brand: getFromJson(json, "brand", FilterOrderBrand.fromString),
          virtual_number: getFromJsonString(json, "virtual_number"),
          is_dn_requested: getFromJson(json, "is_delivery_note_requested", (function (s) {
                  return s === "true";
                })),
          is_business: Belt_Option.flatMap(Json_decode.optional((function (param) {
                      return Json_decode.field("is_business", Json_decode.bool, param);
                    }), json), (function (value) {
                  return value;
                }))
        };
}

function encodeToJson(request) {
  var param = Belt_Option.flatMap(request.source, (function (source) {
          return FilterOrderSource.toString(source);
        }));
  var param$1 = Belt_Option.flatMap(request.order_status, (function (order_status) {
          return FilterOrderStatus.toString(order_status);
        }));
  var param$2 = Belt_Option.flatMap(request.geo_region, (function (geo_region) {
          return geo_region;
        }));
  var param$3 = Belt_Option.flatMap(request.order_type, (function (order_type) {
          return OrderType.toString(order_type);
        }));
  var param$4 = Belt_Option.flatMap(request.start_datetime, (function (date) {
          return Timestamp$Catalyst.toFloat(date).toString();
        }));
  var param$5 = Belt_Option.flatMap(request.end_datetime, (function (date) {
          return Timestamp$Catalyst.toFloat(date).toString();
        }));
  var param$6 = Belt_Option.flatMap(request.brand, (function (brand) {
          return FilterOrderBrand.toString(brand);
        }));
  return Json_encode.object_({
              hd: [
                "order_id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), request.order_id)
              ],
              tl: {
                hd: [
                  "customer_mobile",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), request.customer_mobile)
                ],
                tl: {
                  hd: [
                    "email",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), request.email)
                  ],
                  tl: {
                    hd: [
                      "msisdn",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), request.msisdn)
                    ],
                    tl: {
                      hd: [
                        "driver_mobile",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), request.driver_mobile)
                      ],
                      tl: {
                        hd: [
                          "source",
                          Json_encode.nullable((function (prim) {
                                  return prim;
                                }), param)
                        ],
                        tl: {
                          hd: [
                            "order_status",
                            Json_encode.nullable((function (prim) {
                                    return prim;
                                  }), param$1)
                          ],
                          tl: {
                            hd: [
                              "geo_region",
                              Json_encode.nullable((function (prim) {
                                      return prim;
                                    }), param$2)
                            ],
                            tl: {
                              hd: [
                                "order_type",
                                Json_encode.nullable((function (prim) {
                                        return prim;
                                      }), param$3)
                              ],
                              tl: {
                                hd: [
                                  "start_epoch_millis",
                                  Json_encode.nullable((function (prim) {
                                          return prim;
                                        }), param$4)
                                ],
                                tl: {
                                  hd: [
                                    "end_epoch_millis",
                                    Json_encode.nullable((function (prim) {
                                            return prim;
                                          }), param$5)
                                  ],
                                  tl: {
                                    hd: [
                                      "brand",
                                      Json_encode.nullable((function (prim) {
                                              return prim;
                                            }), param$6)
                                    ],
                                    tl: {
                                      hd: [
                                        "virtual_number",
                                        Json_encode.nullable((function (prim) {
                                                return prim;
                                              }), request.virtual_number)
                                      ],
                                      tl: {
                                        hd: [
                                          "is_delivery_note_requested",
                                          Json_encode.nullable((function (prim) {
                                                  return prim;
                                                }), request.is_dn_requested)
                                        ],
                                        tl: {
                                          hd: [
                                            "is_business",
                                            Json_encode.nullable((function (prim) {
                                                    return prim;
                                                  }), request.is_business)
                                          ],
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function toDict(param) {
  var params = {};
  var setVal = function (value, key) {
    params[key] = value;
    
  };
  ReasonUtils$Catalyst.tap(param.order_id, (function (value) {
          return setVal(value, "order_id");
        }));
  ReasonUtils$Catalyst.tap(param.customer_mobile, (function (value) {
          return setVal(value, "customer_mobile");
        }));
  ReasonUtils$Catalyst.tap(param.email, (function (value) {
          return setVal(value, "email");
        }));
  ReasonUtils$Catalyst.tap(param.msisdn, (function (value) {
          return setVal(value, "msisdn");
        }));
  ReasonUtils$Catalyst.tap(param.driver_mobile, (function (value) {
          return setVal(value, "driver_mobile");
        }));
  ReasonUtils$Catalyst.tap(param.source, (function (value) {
          return setVal(FilterOrderSource.toString(value), "source");
        }));
  ReasonUtils$Catalyst.tap(param.order_status, (function (value) {
          return setVal(FilterOrderStatus.toString(value), "order_status");
        }));
  ReasonUtils$Catalyst.tap(param.geo_region, (function (value) {
          return setVal(value, "geo_region");
        }));
  ReasonUtils$Catalyst.tap(param.order_type, (function (value) {
          return setVal(OrderType.toString(value), "order_type");
        }));
  ReasonUtils$Catalyst.tap(param.start_datetime, (function (value) {
          return setVal(Timestamp$Catalyst.toFloat(value).toString(), "start_epoch_millis");
        }));
  ReasonUtils$Catalyst.tap(param.end_datetime, (function (value) {
          return setVal(Timestamp$Catalyst.toFloat(value).toString(), "end_epoch_millis");
        }));
  ReasonUtils$Catalyst.tap(param.brand, (function (value) {
          return setVal(FilterOrderBrand.toString(value), "brand");
        }));
  ReasonUtils$Catalyst.tap(param.virtual_number, (function (value) {
          return setVal(value, "virtual_number");
        }));
  ReasonUtils$Catalyst.tap(param.is_dn_requested, (function (value) {
          return setVal(Pervasives.string_of_bool(value), "is_delivery_note_requested");
        }));
  ReasonUtils$Catalyst.tap(param.is_business, (function (value) {
          return setVal(Pervasives.string_of_bool(value), "is_business");
        }));
  return params;
}

export {
  t_decode ,
  getFromDict ,
  getFromDictString ,
  getDefaultDateTime ,
  fromDict ,
  getFromJson ,
  getFromJsonString ,
  decodeFilterOrderRequest ,
  encodeToJson ,
  toDict ,
  
}
/* Timestamp-Catalyst Not a pure module */
